import { Toolbar } from '@mui/material';

import React from 'react';

import UserManagementToolbar from '../../../features/Settings/UserManagement/UserManagementToolbar';

interface ICustomUserGridToolBarProps {
	onUserAction: () => void;
}
const CustomUserGridToolBar = (props: ICustomUserGridToolBarProps) => {
	const { onUserAction } = props;
	const onUserActionHandler = () => {
		onUserAction();
	};
	return (
		<Toolbar
			sx={{
				'&.MuiToolbar-root': {
					paddingLeft: 0,
					paddingRight: 0,
				},
			}}
		>
			<UserManagementToolbar onUserAction={onUserActionHandler} />
		</Toolbar>
	);
};
export default CustomUserGridToolBar;
